<div class="navigation-container">
  <div
    class="navigation-step"
    appConfigSettingsNavigationStep
    *ngFor="let step of navigationSettings.steps"
  >
    <span
      title="{{step.label | translate}}"
      class="navigation-step-index"
      [class.active]="step.active"
      [class.finished]="step.finished"
    >{{step.order}}</span>
    <span
      class="navigation-step-label"
    >{{step.label | translate}}</span>
  </div>
</div>
